<app-carousel [typeSearch]="'Beca'"></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <h5 class="mt-0 mb-2">
            <i class="fa-solid fa-graduation-cap"></i>
            Becas
        </h5>
    </div>
</div>